import { Site, getSiteDisplay } from '@aloft/toolkit-shared';
import { Flex } from '@aloft/toolkit-sui';

import { AdjustmentField } from '../../../components/PropertyGrid/fields/AdjustmentField.tsx';
import { LabelField } from '../../../components/PropertyGrid/fields/LabelField.tsx';
import { ReadOnlyField } from '../../../components/PropertyGrid/fields/ReadOnlyField.tsx';
import { getAloftAreaJSONPropertyGridField } from '../../../components/PropertyGrid/fields/utils.tsx';
import { TitleRow } from '../../../components/PropertyGrid/rows/TitleRow.tsx';
import {
  PropertyGridField,
  PropertyGridSectionProps,
} from '../../../components/PropertyGrid/types.ts';

export const AdjustmentsGridSiteExtractionSection = ({
  columnIndex,
  fieldTypes,
}: PropertyGridSectionProps) => {
  const displayLabels = fieldTypes.includes('label');
  const displayAdjustments = fieldTypes.includes('adjustment');

  const influenceField: PropertyGridField<Site> = {
    fieldName: 'editableData.site',
    label: 'Site Influence',
    toDisplayValue: (site) => getSiteDisplay(site).influence,
  };

  const viewField: PropertyGridField<Site> = {
    fieldName: 'editableData.site',
    label: 'View',
    toDisplayValue: (site) => getSiteDisplay(site).view,
  };

  return (
    <>
      <TitleRow
        columnIndex={columnIndex}
        fieldTypes={fieldTypes}
        title="Site Extraction Adjustments"
      />
      {displayLabels && (
        <LabelField
          columnIndex={columnIndex}
          field={{
            fieldName: 'editableData.site.area',
            label: 'Site Size',
            manualAdjustmentKey: 'site',
          }}
        />
      )}
      <ReadOnlyField
        columnIndex={columnIndex}
        field={getAloftAreaJSONPropertyGridField('editableData.site.area', 'Site Size')}
      />
      {displayAdjustments && (
        <Flex gridRow="span 3">
          <AdjustmentField
            columnIndex={columnIndex}
            field={{
              fieldName: 'editableData.site',
              label: 'Site Adjustment',
              manualAdjustmentKey: 'site',
            }}
          />
        </Flex>
      )}
      {displayLabels && (
        <LabelField
          columnIndex={columnIndex}
          field={{
            fieldName: 'editableData.site.influence',
            label: 'Site Influence',
            manualAdjustmentKey: 'site',
          }}
        />
      )}
      <ReadOnlyField columnIndex={columnIndex} field={influenceField} />
      {displayLabels && (
        <LabelField
          columnIndex={columnIndex}
          field={{
            fieldName: 'editableData.site.view',
            label: 'View',
            manualAdjustmentKey: 'site',
          }}
        />
      )}
      <ReadOnlyField columnIndex={columnIndex} field={viewField} />
    </>
  );
};
